(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-breadcrumbs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const breadcrumb = document.getElementById('enhanced-breadcrumb');
  if (!breadcrumb || !breadcrumb.dataset) return;

  const STORAGE_KEY = 'specktrum_breadcrumb_context';
  const STORAGE_DURATION = 30 * 60 * 1000;
  const NAV_FLAG_KEY = 'specktrum_breadcrumb_from_product';

  const productCollections = (breadcrumb.dataset.productCollections || '').split(',').filter(Boolean);
  const currentCollectionHandle = breadcrumb.dataset.currentCollection;
  const currentCollectionTitle = breadcrumb.dataset.currentCollectionTitle;
  const currentCollectionUrl = breadcrumb.dataset.currentCollectionUrl;

  const fallbackCollectionHandle = breadcrumb.dataset.fallbackCollectionHandle;
  const fallbackCollectionTitle = breadcrumb.dataset.fallbackCollectionTitle;
  const fallbackCollectionUrl = breadcrumb.dataset.fallbackCollectionUrl;

  const collectionItem = breadcrumb.querySelector('.breadcrumb__collection-item');
  const collectionLink = breadcrumb.querySelector('#breadcrumb-collection-link');

  if (!collectionItem || !collectionLink) return;

  function saveCollectionContext(collectionData) {
    const contextData = {
      ...collectionData,
      timestamp: Date.now(),
      expires: Date.now() + STORAGE_DURATION
    };

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(contextData));
    } catch (e) {
      console.warn('Could not save breadcrumb context:', e);
    }
  }

  function getStoredCollectionContext() {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      if (!stored) return null;

      const contextData = JSON.parse(stored);

      if (Date.now() > contextData.expires) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return contextData;
    } catch (e) {
      console.warn('Could not retrieve breadcrumb context:', e);
      return null;
    }
  }

  function updateBreadcrumbDisplay(collectionData) {
    if (!collectionData || !collectionData.handle || !collectionData.title || !collectionData.url) {
      collectionItem.style.display = 'none';
      breadcrumb.classList.add('is-ready');
      return;
    }

    collectionLink.href = collectionData.url;
    collectionLink.textContent = collectionData.title;
    collectionItem.style.display = '';
    breadcrumb.classList.add('is-ready');
  }

  function initializeBreadcrumb() {
    const fromProductNav = sessionStorage.getItem(NAV_FLAG_KEY) === '1';
    if (fromProductNav) {
      sessionStorage.removeItem(NAV_FLAG_KEY);
    }

    const storedContext = getStoredCollectionContext();

    if (fromProductNav && storedContext && productCollections.includes(storedContext.handle)) {
      updateBreadcrumbDisplay(storedContext);
      return;
    }

    if (currentCollectionHandle && currentCollectionTitle && currentCollectionUrl && currentCollectionHandle !== 'all-products') {
      const collectionData = {
        handle: currentCollectionHandle,
        title: currentCollectionTitle,
        url: currentCollectionUrl
      };
      saveCollectionContext(collectionData);
      updateBreadcrumbDisplay(collectionData);
      return;
    }

    if (storedContext && productCollections.includes(storedContext.handle)) {
      updateBreadcrumbDisplay(storedContext);
      return;
    }

    if (fallbackCollectionHandle && fallbackCollectionTitle && fallbackCollectionUrl) {
      const fallbackCollectionData = {
        handle: fallbackCollectionHandle,
        title: fallbackCollectionTitle,
        url: fallbackCollectionUrl
      };
      saveCollectionContext(fallbackCollectionData);
      updateBreadcrumbDisplay(fallbackCollectionData);
      return;
    }

    sessionStorage.removeItem(STORAGE_KEY);
    collectionItem.style.display = 'none';
    breadcrumb.classList.add('is-ready');
  }

  function trackProductNavigation() {
    const productLinks = document.querySelectorAll('a[href*="/products/"]');

    productLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        try {
          sessionStorage.setItem(NAV_FLAG_KEY, '1');
        } catch (e) {}

        const storedContext = getStoredCollectionContext();
        if (storedContext && storedContext.handle && storedContext.handle !== 'all-products') {
          saveCollectionContext(storedContext);
          return;
        }

        if (currentCollectionHandle && currentCollectionTitle && currentCollectionHandle !== 'all-products') {
          saveCollectionContext({
            handle: currentCollectionHandle,
            title: currentCollectionTitle,
            url: currentCollectionUrl
          });
          return;
        }

        if (fallbackCollectionHandle && fallbackCollectionTitle && fallbackCollectionUrl) {
          saveCollectionContext({
            handle: fallbackCollectionHandle,
            title: fallbackCollectionTitle,
            url: fallbackCollectionUrl
          });
        }
      });
    });

    const featuredLinks = document.querySelectorAll('.mega-menu__featured-links a');
    featuredLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        try {
          sessionStorage.setItem(NAV_FLAG_KEY, '1');
        } catch (e) {}

        const storedContext = getStoredCollectionContext();
        if (storedContext && storedContext.handle && storedContext.handle !== 'all-products') {
          saveCollectionContext(storedContext);
          return;
        }

        if (currentCollectionHandle && currentCollectionTitle && currentCollectionHandle !== 'all-products') {
          saveCollectionContext({
            handle: currentCollectionHandle,
            title: currentCollectionTitle,
            url: currentCollectionUrl
          });
          return;
        }

        if (fallbackCollectionHandle && fallbackCollectionTitle && fallbackCollectionUrl) {
          saveCollectionContext({
            handle: fallbackCollectionHandle,
            title: fallbackCollectionTitle,
            url: fallbackCollectionUrl
          });
        }
      });
    });
  }

  initializeBreadcrumb();
  trackProductNavigation();
});

  } catch(e) { console.error(e); }
})();
})();
